import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(_vm.show)?_c('NavBar',{attrs:{"newNotifications":_vm.newNotifications},on:{"logout":_vm.logout}}):_vm._e(),(_vm.isRegisterUser)?_c('StateOfMind',{attrs:{"value":_vm.dialog},on:{"setDialog":_vm.recordEmotion}}):_vm._e(),_c(VMain,{staticClass:"v-main ml-12"},[_c(VContainer,{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }